import { render, staticRenderFns } from "./sharedClient.vue?vue&type=template&id=a805f44e&scoped=true&"
import script from "./sharedClient.vue?vue&type=script&lang=js&"
export * from "./sharedClient.vue?vue&type=script&lang=js&"
import style0 from "./sharedClient.vue?vue&type=style&index=0&id=a805f44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a805f44e",
  null
  
)

export default component.exports